var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkasunread(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 4.66667H9.1C7.13982 4.66667 6.15972 4.66667 5.41103 5.04814C4.75247 5.3837 4.21703 5.91913 3.88148 6.5777C3.5 7.32639 3.5 8.30648 3.5 10.2667V16.3333C3.5 17.4183 3.5 17.9608 3.61926 18.4059C3.94289 19.6137 4.88631 20.5571 6.09413 20.8807C6.53922 21 7.0817 21 8.16667 21V23.7248C8.16667 24.3464 8.16667 24.6572 8.2941 24.8169C8.40493 24.9557 8.57298 25.0365 8.75063 25.0363C8.9549 25.0361 9.19762 24.8419 9.68305 24.4536L12.4661 22.2271C13.0346 21.7723 13.3189 21.5449 13.6354 21.3832C13.9162 21.2397 14.2152 21.1349 14.5241 21.0715C14.8723 21 15.2363 21 15.9644 21H17.7333C19.6935 21 20.6736 21 21.4223 20.6185C22.0809 20.283 22.6163 19.7475 22.9519 19.089C23.3333 18.3403 23.3333 17.3602 23.3333 15.4V15.1667M23.4749 4.52513C24.8417 5.89196 24.8417 8.10804 23.4749 9.47487C22.108 10.8417 19.892 10.8417 18.5251 9.47487C17.1583 8.10804 17.1583 5.89196 18.5251 4.52513C19.892 3.15829 22.108 3.15829 23.4749 4.52513Z",
    stroke: "#121215",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkasunread);
export default __webpack_public_path__ + "static/media/Mark as unread.3e24f3526118425d22d48475a122ec08.svg";
export { ForwardRef as ReactComponent };